import { Route, Routes } from 'react-router';
import './styles/landing.css';
import './styles/legal.css';
import LandingPage from './pages/LandingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import ScrollToAnchor from './components/ScrollToAnchor';

function App() {
  return (
    <>
      <ScrollToAnchor />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Firebase Hosting rewrites every unknown path to index.html, so an
            unmatched route here is a mistyped URL rather than a missing file.
            The landing page is the useful answer. */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </>
  );
}

export default App;
